import { useMemo } from 'react'
import { v5 as uuidv5 } from 'uuid'

/**
 * Custom hook to get a csrf-token.
 */
export const useCsrfToken = key => useMemo(() => uuidv5(key, uuidv5.DNS), [key])
